export default "__VITE_ASSET__4ff6dd52__"